import { useState, useRef, useEffect } from "react"
import eventdata from "../data/events.json";
import MemberForm from "./MemberForm";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Aryans from "../assets/logos/Aryans.png"
import Mughals from "../assets/logos/Mughals.png"
import Rajputs from "../assets/logos/Rajputs.png"
import Spartans from "../assets/logos/Spartans.png"
import Vikings from "../assets/logos/Vikings.png"

const Registration = (props) => {

	const formRef = useRef(null)
	const [loading, setLoading] = useState(false)
	const [event, setEvent] = useState(Object.keys(eventdata)[0])
	const [isTeam, setIsTeam] = useState(false)

	const scriptUrl = "https://script.google.com/macros/s/AKfycbwYPYgsfOaKDEe7RLmtawbxCSBmwXBft1tpSxsScBoVuFMFR4vNd4nyY9WXvrWs-pIWBA/exec"

	const houseImage = {
		"Aryans": Aryans,
		"Mughals": Mughals,
		"Rajputs": Rajputs,
		"Spartans": Spartans,
		"Vikings": Vikings
	}

	const handleSubmit = (e) => {
		e.preventDefault()
		setLoading(true)

		fetch(scriptUrl, {
			method: "POST",
			body: new FormData(formRef.current),
		}).then(res => {
			console.log("SUCCESSFULLY SUBMITTED")
			setLoading(false)
			formRef.current.reset();
			toast.success('Successfully Submitted', {
				position: "top-right",
				autoClose: 3000,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "dark",
			});
			// formRef.current["Name-1"].value = "";
			// formRef.current["Department-1"].value = "";
			// formRef.current["Uid-1"].value = "";
		})
		.catch((err) => {
			console.log(err)
			setLoading(false)
			alert("Not Submitted, Please adhere to the guidelines and try again.")
		})
	}

	useEffect(() => {
		setIsTeam(eventdata[event].type === "team" ? true : false)
	}, [event])

	return (
		<form ref={formRef} onSubmit={handleSubmit} name="google-sheet" className="mt-8">

			<ToastContainer />

			<h3 className="my-4 text-lg font-semibold">Please enter the details of each individual or team and click submit to register for an event.</h3>

			<div className="select-none mb-4">
				<label htmlFor="House" className="block font-medium mb-2">House*</label>
				{/* <select name="House" defaultValue={props.house} className="block appearance-none text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow" required disabled>
                    <option value={props.house} id={props.house}>{props.house}</option>
                </select> */}
				<input type="text" value={props.house} name="House" className="select-none block text-gray-800 w-full bg-slate-300 px-4 py-2 pr-8 rounded-sm shadow" />
			</div>

			<div className="mb-4 flex flex-col">
				<label htmlFor="Event" className="block font-medium mb-2">Event*</label>
				<select name="Event" value={event} onChange={(e) => setEvent(e.target.value)} className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow" required>
					{Object.keys(eventdata).map((event) => {
						return <option value={event} id={event}>{eventdata[event].title}</option>
					})}
				</select>
			</div>

			<div className="hidden">
				<input name="Code" value={eventdata[event].code + (Math.floor(Math.random() * 900) + 100)} required />
			</div>

			{/* <div className="hidden">
                <input name="No" value={Math.floor(Math.random() * 900) + 100} required />
            </div> */}

			{
				eventdata[event].registration ? (
					[...Array(eventdata[event].no_of_members)].map((e, i) => <MemberForm number={i + 1} isTeam={isTeam} />)
				) : <div className="text-center text-2xl font-bold my-24">Registration Not Open</div>
			}

			{
				eventdata[event].registration ? (
					<div className="mt-8">
						<input type="submit" value={loading ? "Loading..." : "SUBMIT"} className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-sm shadow-sm text-white bg-amber-500 hover:bg-amber-600" />
					</div>
				) : null
			}

			<div className="grid grid-cols-4 border-t mt-8 pt-4 text-justify">
				<img className="mx-auto select-none w-64 col-span-full lg:col-span-1" src={houseImage[props.house]} alt="house" />
				<div className="col-span-full lg:col-span-3">
					<p className="my-2">• Co-Captains of all houses are permitted to participate in a maximum of <b>5</b> events, out of which at least <b>2</b> must be written literary events.</p>
					<p className="my-2">• Participation limit for written literary events is set at <b>12 individuals</b> and <b>2 teams</b> per house for group events.</p>
					<p className="my-2">• Individual participants are allowed to compete in up to <b>5</b> events, and group participants in up to <b>3</b> events, excluding written literary events.</p>
					<p className="my-2">• The maximum number of participants from each house in individual stage events is limited to <b>5</b>, and for group stage events, only <b>1 team</b> is allowed per house.</p>
					<p className="my-2">• Failure to comply will result in immediate disqualification.</p>
				</div>
			</div>

		</form>
	);
};

export default Registration;
